import { useContext } from 'react';
import { AiContext } from '../context';

export function useAi() {
  const context = useContext(AiContext);
  return { ...context };
}
